














import {
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    Inject,
    InjectComponent, Mixins,
    NumericQuestionCondition,
    NumericValueQuestion,
    Prop,
    VueComponent
} from "@zoovu/runner-browser-api";
import {QuestionConfiguration} from "../configuration";
import QuestionBaseMixin from "./question-base.vue";
import {formatNumberForRangeAndSliderQuestionTypes} from "./utils"

@Component({})
export default class SliderQuestionView extends Mixins(QuestionBaseMixin) {
    @Inject() readonly localizationSettings!: LocalizationSettings;

    @Prop({type: [Number, String]})
    sliderWidth: string | number;

    @Prop({default: false})
    isFilterQuestion: boolean;

    @Prop()
    question: NumericValueQuestion;

    @ComponentConfig(QuestionConfiguration)
    componentConfiguration: QuestionConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("Slider")
    slider: VueComponent;

    @InjectComponent("QuestionValidationMessageView")
    questionValidationMessageView: VueComponent;

    @InjectComponent("QuestionHeadView")
    questionHeadView: VueComponent;

    sliderValue = null;

    onValueChange(value) {
        this.sliderValue = value;
    }

    onValueChanged(value) {
        if (value !== this.question.value) {
            this.question.setValue(value);
        }
    }

    formatValue(value: number) {
      return formatNumberForRangeAndSliderQuestionTypes(value, this.question.unit ?? this.localizationSettings?.currencyCode, this.localizationSettings?.locale);
    }

    get eventsListeners() {
        const valueChangeEventName =
            this.question.condition === NumericQuestionCondition.GREATER_THAN_OR_EQUAL ? "left-value-change" : "right-value-change";

        const valueChangedEventName =
            this.question.condition === NumericQuestionCondition.GREATER_THAN_OR_EQUAL ? "left-value-changed" : "right-value-changed";

        const valueAdjustedEventName =
            this.question.condition === NumericQuestionCondition.GREATER_THAN_OR_EQUAL ? "left-value-adjusted" : "right-value-adjusted";

        return {
            [valueChangeEventName]: this.onValueChange,
            [valueAdjustedEventName]: this.onValueChange,
            [valueChangedEventName]: this.onValueChanged
        };
    }

    get sliderOptions() {
        const valueName = this.question.condition === NumericQuestionCondition.GREATER_THAN_OR_EQUAL ? "leftValue" : "rightValue";

        return {
            min: this.question.min,
            max: this.question.max,
            step: this.question.step,

            leftValueAdjustable: !this.question.readOnly && this.question.condition === NumericQuestionCondition.GREATER_THAN_OR_EQUAL,
            rightValueAdjustable: !this.question.readOnly && this.question.condition === NumericQuestionCondition.LESS_THAN_OR_EQUAL,

            [valueName]: this.questionValue
        };
    }

    get questionValue() {
        const value = this.question.value;
        return value === null || typeof value === "undefined" ? this.question.defaultValue : value;
    }

    get displayedValue() {
        if (this.sliderValue != null) {
            return this.sliderValue
        }
        return this.questionValue;
    }

    get showImage() {
        return this.componentConfiguration.showImages == true && this.question.images != null && this.question.images[0] != null;
    }

    get filterClass() {
        return {
            "filter-slider-box": this.isFilterQuestion,
        };
    }

    beforeMount(): void {
        if (!this.question.isMandatory) {
            this.question.setValue(this.questionValue);
        }
    }
}
